import Vue from 'vue';
import store from '../store';
import moment from 'moment-timezone';

const filters = {

  currentDate () {
    return moment();
  },

  formatUnix: (value) => {
    if (value) {
      return moment(value).unix();
    }
  },

  formatDate: (value) => {
    if (value) {
      return moment.unix(value).tz(store.getters.user.TimeZone)
        .format(store.getters.user.UserFormaterData.DateFormat);
    }
  },

  formatDatetime: (value) => {
    if (value) {
      return moment.unix(value).tz(store.getters.user.TimeZone)
        .format(store.getters.user.UserFormaterData.DatetimeFormat);
    }
  },

  formatStartDeadline: (value) => {
    if (value) {
      return moment.unix(value).tz(store.getters.user.TimeZone)
        .format('DD.MM.YYYY HH:mm [GMT] Z');
    }
  },

  onlyData: (value) => {
    if (value) {
      return moment.unix(value).format('DD.MM.YYYY');
    }
  },

  onlyTime: (value) => {
    if (value) {
      return moment.unix(value).format('HH:mm [GMT] Z');
    }
  },

  dateAndTime: (value) => {
    if (value) {
      return moment.unix(value).format('HH:mm DD.MM.YYYY');
    }
  },

  formatJsDate: (value) => {
    if (value) {
      return moment(value).toDate();
    }
  },

  /**
     * Method for convert file size
     *
     * @param {String} fileSize
     */
  convertSizeFile (fileSize) {
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let l = 0;
    let n = parseInt(fileSize, 10) || 0;
    while (n >= 1024 && ++l) {
      n = n / 1024;
    }
    return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
  },

};

Vue.filter('formatDate', filters.formatDate);
Vue.filter('formatDatetime', filters.formatDatetime);
Vue.filter('formatStartDeadline', filters.formatStartDeadline);
Vue.filter('onlyData', filters.onlyData);
Vue.filter('onlyTime', filters.onlyTime);
Vue.filter('dateAndTime', filters.dateAndTime);
Vue.filter('formatUnix', filters.formatUnix);
Vue.filter('currentDate', filters.currentDate);
Vue.filter('formatJsDate', filters.formatJsDate);
Vue.filter('convertSizeFile', filters.convertSizeFile);
Vue.prototype.$filters = filters;
